import React, { createContext, useContext, useState, ReactNode } from 'react';

interface StabilityContextType {
  adaptiveThresholds: Record<string, number>;
  setThreshold: (key: string, value: number) => void;
  systemStability: number;
}

const StabilityContext = createContext<StabilityContextType | undefined>(undefined);

export const StabilityProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [adaptiveThresholds, setAdaptiveThresholds] = useState<Record<string, number>>({
    risk: 0.75,
    margin: 0.20,
  });

  const setThreshold = (key: string, value: number) => {
    setAdaptiveThresholds(prev => ({ ...prev, [key]: value }));
  };

  const systemStability = 0.98; // Simulated

  return (
    <StabilityContext.Provider value={{ adaptiveThresholds, setThreshold, systemStability }}>
      {children}
    </StabilityContext.Provider>
  );
};

export const useStability = () => {
  const context = useContext(StabilityContext);
  if (context === undefined) {
    throw new Error('useStability must be used within a StabilityProvider');
  }
  return context;
};
